import {
  PacketModule,
  createPacketServices
} from "./chunk-EMLP6XTP.mjs";
import "./chunk-KEIR6QF5.mjs";
export {
  PacketModule,
  createPacketServices
};
